<template>
  <div class="">
    <div class="wmsTitle titleImg">
        <img  class="image" src="./WMS/WMStitle.png" alt="">
    </div>
    <div class="WMSicon">
        <img  class="image" src="./WMS/WMSicon.png"  alt="">
    </div>
    <div class="wmsTitle1 WMSfour">
        <img class="image" src="./WMS/WMSfour.png"  alt="">
    </div>
    <div class="wmsTitle1 WMSfour">
        <img class="image" src="./WMS/WMSthree.png"  alt="">
    </div>
    <div class="wmsTitle1 WMStwo">
        <img class="image" src="./WMS/WMStwo.png"  alt="">
    </div>
    <div class="wmsTitle1 WMSone">
        <img class="image" src="./WMS/WMSone.png"  alt="">
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
// pc高度比
// $sun:75/192;
$sun:100/192;
.wmsTitle{
    display: flex;
    justify-content: center;
    background-color: #FFFFFF;
    width: 100%;

}
.titleImg{
  height: 460px*$sun;
}
.wmsTitle1{
  width: 1200px*$sun;
  margin: 0 auto;
}
.image{
      width: 100%;
      height: 100%;
    }
.WMSicon{
  width: 252px*$sun;
  height: 107px*$sun;
  margin: 50px*$sun auto;
}
.WMSfour{
  padding-bottom: 40px*$sun;
}
.WMStwo{
  padding-bottom: 60px*$sun;
}
.WMSone{
  padding-bottom: 60px*$sun;
}
</style>
